import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";

@Component({
  selector: "app-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
})
export class TableComponent {
  @Input() columnLabels: string[];
  @Input() data: any[];
  @Input() page: number;
  @Input() totalItems: number;
  @Input() canEdit = true;
  @Input() canDelete = true;
  @Input() emptyMessage = "Não há dados";
  @Input() totalPerPage = 10;
  @Input() showDefaultActionButton = true;
  @Input() showDropdownActionButton = false;
  @Input() actions: { title: string; action: (arg: any) => void }[] = [];
  @Input() showFooterLabel = false;
  @Input() removeScrool = false;

  @ContentChild("items") items!: TemplateRef<any>;
  @ContentChild("header") header!: TemplateRef<any>;

  @Output() removeItemEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateItemEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() pageChangeEvent: EventEmitter<number> = new EventEmitter<number>();

  get startItem(): number {
    if (this.page === 1) return 1;

    return this.page + this.totalPerPage - 1;
  }

  get endItem(): number {
    const lastPositionPerPage = this.totalPerPage * this.page;

    if (lastPositionPerPage > this.totalItems) return this.totalItems;

    return lastPositionPerPage;
  }

  update(item) {
    this.updateItemEvent.emit(item);
  }

  remove(item) {
    this.removeItemEvent.emit(item);
  }
}
